"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceType = exports.Provider = exports.SourceState = void 0;
var sources_1 = require("../grand-central/db/sources");
Object.defineProperty(exports, "SourceState", { enumerable: true, get: function () { return sources_1.SourceState; } });
var Provider;
(function (Provider) {
    Provider["City"] = "city";
    Provider["Places"] = "places";
    Provider["PointsOfInterest"] = "points-of-interest";
    Provider["GeoEntity"] = "geo-entity";
})(Provider = exports.Provider || (exports.Provider = {}));
/** A string that indicates where the `place` was sourced from on NAPI's tables. */
var PlaceType;
(function (PlaceType) {
    PlaceType["City"] = "city";
    PlaceType["Location"] = "location";
    PlaceType["PointOfInterest"] = "point-of-interest";
})(PlaceType = exports.PlaceType || (exports.PlaceType = {}));
//# sourceMappingURL=types.js.map